var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVarianceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.126,
    height: 19.439,
    viewBox: "0 0 22.126 19.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    width: 22.126,
    height: 19.439,
    fill: "#ebf8ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5389",
    "data-name": "Path 5389",
    d: "M19.186,7.749A4.216,4.216,0,0,0,16.884,0a4.187,4.187,0,0,0-3.737,2.256A4.173,4.173,0,0,0,11.1,1.71a4.219,4.219,0,0,0-2.119.569A4.213,4.213,0,1,0,2.939,7.748,5.205,5.205,0,0,0,0,12.443v2.8A1.717,1.717,0,0,0,.592,16.5c.934.866,2.848,1.208,4.648,1.208.273,0,.524,0,.8-.023a2.21,2.21,0,0,0,.957.934,9.094,9.094,0,0,0,4.124.82,8.913,8.913,0,0,0,4.17-.866,1.974,1.974,0,0,0,.888-.911c.25.023.525.023.8.023,1.777,0,3.669-.342,4.581-1.208a1.609,1.609,0,0,0,.569-1.253v-2.78a5.311,5.311,0,0,0-2.939-4.694Zm-2.3-6.608a3.076,3.076,0,0,1,0,6.153,3.039,3.039,0,0,1-1.664-.5,3.578,3.578,0,0,0,.091-.866,4.278,4.278,0,0,0-1.23-2.985,3.062,3.062,0,0,1,2.8-1.8ZM14.173,5.925A3.076,3.076,0,1,1,11.1,2.849a3.092,3.092,0,0,1,3.076,3.076M2.164,4.217a3.074,3.074,0,0,1,5.9-1.208A4.218,4.218,0,0,0,6.88,5.925a3.456,3.456,0,0,0,.091.843,3.041,3.041,0,0,1-1.731.524A3.093,3.093,0,0,1,2.164,4.217Zm3.691,9.958v2.37c-1.937.091-3.8-.273-4.489-.888a.529.529,0,0,1-.228-.41v-2.8A4.1,4.1,0,0,1,4.694,8.387a4.436,4.436,0,0,0,.547.046,4.432,4.432,0,0,0,.547-.046A4.124,4.124,0,0,1,8.318,9.731a5.3,5.3,0,0,0-2.462,4.443Zm9.32,2.8c0,.205-.159.41-.5.615-1.572.934-5.515.934-7.132.023-.365-.205-.547-.433-.547-.638v-2.8a4.088,4.088,0,0,1,3.6-4.056,3.691,3.691,0,0,0,.5.023c.159,0,.319-.023.478-.023a4.088,4.088,0,0,1,3.6,4.056Zm5.788-1.732a.558.558,0,0,1-.205.41c-.661.615-2.529.98-4.443.888v-2.37A5.185,5.185,0,0,0,13.83,9.731,3.993,3.993,0,0,1,16.336,8.41a4.432,4.432,0,0,0,.547.046,4.436,4.436,0,0,0,.547-.046,4.081,4.081,0,0,1,3.532,4.056Z",
    transform: "translate(0 0)",
    fill: "#ebf8ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarianceLight);
export default __webpack_public_path__ + "static/media/variance_light.ac36d673937bfe23e2df4c491b61d591.svg";
export { ForwardRef as ReactComponent };